.ActionMenu {
  --focus-outline-width: 3px;
  position: relative;
}

.ActionMenu--disabled {
  cursor: not-allowed;
}

.ActionMenu__button {
  height: auto;
}

.ActionMenu__button--default {
  /* avoid specificity issues */
  --brand-borderRadius-medium: var(--brand-borderRadius-full);
}

.ActionMenu__button--small {
  padding: calc(var(--base-size-4) / 2) var(--base-size-12);
}

.ActionMenu__button--medium {
  padding: calc(var(--base-size-8) + 2px) var(--base-size-28);
}

.ActionMenu__button > span:first-of-type {
  max-width: 200px;
  overflow: hidden;
}

.ActionMenu__button--split-button {
  display: inline-flex;
  padding: 0;
  border-radius: var(--brand-borderRadius-medium);
  border: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
  background-color: var(--brand-color-canvas-default);
}

.ActionMenu__innerButton--split-button.ActionMenu__innerButton--split-button-primary,
.ActionMenu__innerButton--split-button.ActionMenu__innerButton--split-button-primary:hover {
  position: relative;
  z-index: 1;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ActionMenu__innerButton--split-button.ActionMenu__innerButton--split-button-primary::before,
.ActionMenu__innerButton--split-button.ActionMenu__innerButton--split-button-primary:hover::before {
  content: '';
  position: absolute;
  top: calc(var(--base-size-2) / -2);
  right: calc(var(--base-size-2) * -1);
  width: var(--brand-borderWidth-thin);
  height: calc(100% + var(--base-size-2));
  background-color: var(--brand-ActionMenu-color-splitButton-divider-default);
}

.ActionMenu__innerButton--primary.ActionMenu__innerButton--split-button.ActionMenu__innerButton--split-button-primary::before {
  background-color: var(--brand-ActionMenu-color-splitButton-divider-primary);
}

.ActionMenu__innerButton--subtle.ActionMenu__innerButton--split-button.ActionMenu__innerButton--split-button-primary::before {
  top: calc(var(--base-size-2) * -1);
  height: calc(100% + var(--base-size-4));
}

.ActionMenu__innerButton--subtle.ActionMenu__innerButton--split-button.ActionMenu__innerButton--split-button-primary:active::before {
  width: 0;
}

.ActionMenu__innerButton--medium.ActionMenu__innerButton--split-button,
.ActionMenu__innerButton--split-button.ActionMenu__innerButton--split-button-menu {
  padding: var(--brand-control-medium-paddingBlock-condensed) var(--brand-control-medium-paddingInline-normal); /* Override the default button padding */
}

.ActionMenu__inner-button-dropdown-icon {
  vertical-align: middle !important;
}

.ActionMenu__innerButton--split-button.ActionMenu__innerButton--split-button-menu {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  position: relative;
  z-index: 0;
}

.ActionMenu__innerButton--disabled {
  cursor: not-allowed;
  pointer-events: none;
}

.ActionMenu__menu {
  position: absolute;
  z-index: 100;
  padding: var(--base-size-12);
  min-width: min-content;
  visibility: hidden;
  background-color: var(--brand-color-canvas-default);
  border: var(--brand-borderWidth-thin) solid var(--brand-color-border-muted);
  border-radius: var(--brand-borderRadius-large);
  max-height: 460px;
  overflow-y: auto;
  box-shadow: 0px 100px 80px rgba(0, 0, 0, 0.01), 0px 41px 33px rgba(0, 0, 0, 0.02), 0px 22px 17px rgba(0, 0, 0, 0.02),
    0px 12px 10px rgba(0, 0, 0, 0.03), 0px 6px 5px rgba(0, 0, 0, 0.04), 0px 2px 2px rgba(0, 0, 0, 0.07);
}

.ActionMenu__menu--small {
  padding: var(--base-size-8);
}

.ActionMenu__menu--medium {
  padding: var(--base-size-12);
}

.ActionMenu__menu--visible {
  visibility: visible;
}

.ActionMenu__menu--pos-outside-bottom {
  animation: 189ms var(--brand-animation-easing-glide) 0s 1 normal none running overlay-appear-outside-bottom;
}

.ActionMenu__menu--pos-outside-top {
  animation: 189ms var(--brand-animation-easing-glide) 0s 1 normal none running overlay-appear-outside-top;
}

@keyframes overlay-appear-outside-bottom {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes overlay-appear-outside-top {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.ActionMenu__menu--medium.ActionMenu__menu--pos-outside-bottom {
  margin-block-start: var(--base-size-8);
}

.ActionMenu__menu--medium.ActionMenu__menu--pos-outside-top {
  margin-block-start: calc(var(--base-size-8) * -1);
}

.ActionMenu__menu--small.ActionMenu__menu--pos-outside-bottom {
  margin-block-start: var(--base-size-4);
}

.ActionMenu__menu--small.ActionMenu__menu--pos-outside-top {
  margin-block-start: calc(var(--base-size-4) * -1);
}

.ActionMenu__menu::-webkit-scrollbar {
  width: var(--base-size-12);
}

.ActionMenu__menu::-webkit-scrollbar-track {
  border-left: 1px solid var(--brand-color-border-muted);
  border-top-right-radius: var(--brand-borderRadius-large);
  border-bottom-right-radius: var(--brand-borderRadius-large);
}

.ActionMenu__menu::-webkit-scrollbar-thumb {
  border-radius: var(--brand-borderRadius-medium);
  border: 1px solid var(--brand-color-border-default);
  background-color: var(--brand-ActionMenu-color-scrollbar-thumb-bg);
}

.ActionMenu__item {
  flex: 1 0 auto;
  display: grid;
  align-items: center;
  grid-template-areas: 'leadingVisual text';
  grid-template-columns: min-content 1fr;
  list-style: none;
  border-radius: var(--brand-borderRadius-medium);
}

.ActionMenu__item-anchor {
  display: grid;
  grid-template-columns: subgrid;
  grid-template-rows: subgrid;
  grid-column: 1 / -1;
  grid-row: 1 / -1;
  align-items: center;
  gap: var(--base-size-8);
  text-decoration: none;
  color: var(--brand-color-text-default);
}

.ActionMenu__item-anchor--disabled {
  pointer-events: none;
  cursor: not-allowed;
}

.ActionMenu__item-anchor:focus-visible {
  outline: none;
  box-shadow: none;
}

.ActionMenu__item:has(.ActionMenu__item-anchor:focus-visible) {
  outline: none;
  box-shadow: 0 0 0 var(--focus-outline-width) var(--brand-color-focus);
  transition: none;
}

.ActionMenu__item--medium {
  padding: var(--brand-control-medium-paddingBlock-condensed) var(--brand-control-medium-paddingInline-normal);
  min-height: var(--brand-control-medium-size);
}

.ActionMenu__item--medium:has(.ActionMenu__item-anchor) {
  padding: 0;
}

.ActionMenu__item--medium .ActionMenu__item-anchor {
  padding: var(--brand-control-medium-paddingBlock-condensed) var(--brand-control-medium-paddingInline-normal);
}

.ActionMenu__item--small {
  padding: var(--base-size-8) var(--brand-control-small-paddingInline-condensed);
}

.ActionMenu__item[aria-disabled='true'] {
  cursor: not-allowed;
}

.ActionMenu__item:hover:not(.ActionMenu__item[aria-disabled='true']) {
  cursor: pointer;
  background-color: var(--brand-ActionMenu-color-item-hover);
}

.ActionMenu__item--selection-type-single {
  padding-right: var(--base-size-48);
}

.ActionMenu__item:focus-visible {
  outline: none;
  box-shadow: 0 0 0 var(--focus-outline-width) var(--brand-color-focus);
  transition: none;
}

.ActionMenu__item-leadingVisual {
  display: flex;
  min-width: var(--base-size-16);
  margin-right: var(--brand-control-medium-gap);
  color: var(--brand-color-text-default);
  pointer-events: none;
  grid-area: leadingVisual / leadingVisual;
}

.ActionMenu__item-text {
  grid-area: text / text;
  /* display grid collapses the text line box height for optical alignment */
  display: grid;
  width: max-content;
}

.ActionMenu__item-text > span {
  line-height: var(--brand-control-medium-lineBoxHeight);
}

.ActionMenu__item-icon {
  fill: var(--brand-color-text-default);
}

.ActionMenu__item-content--disabled {
  color: var(--base-color-scale-gray-3);
}

.ActionMenu__item-icon--disabled {
  fill: var(--base-color-scale-gray-3);
}

@media (forced-colors: active) {
  .ActionMenu__item:focus-visible {
    outline: var(--brand-borderWidth-thick) solid Highlight;
    outline-offset: var(--base-size-2);
  }
}

/* Remove all animations, transitions and smooth scroll for people that prefer not to see them */
@media (prefers-reduced-motion: reduce) {
  .ActionMenu,
  .ActionMenu::before,
  .ActionMenu::after,
  .ActionMenu * {
    animation: none !important;
    transition: none !important;
    scroll-behavior: auto !important;
  }
}
